/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { languageSchema } from './language-schema';
import { opportunitySchema } from './opportunity-schema';
import { LanguageProficiency, LanguageSkill } from "../enums";

export const opportunityLanguageSchema: z.AnyZodObject = z.object({
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  language: z.lazy(() => languageSchema).nullish(),
  languageId: z.string().uuid().nullish(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  requiredLanguageProficiency: 
    z.nativeEnum(LanguageProficiency)
  .nullish(),
  requiredLanguageSkill: z.nativeEnum(LanguageSkill).nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type OpportunityLanguage = z.infer<typeof opportunityLanguageSchema>;
